import logo from '../../../Assets/Video/Intro.mp4';
import './ProductPanel.css';

/**
 * The product itself, in a tall panel.
 *
 * Shared because Magbit has two entrances, the landing page and the sign-in
 * screen, and they should show the same thing in the same frame. A copy of
 * this beside each of them drifted within a day.
 *
 * The second shot is decorative: the first one carries the description, and
 * two alt texts for one picture of the same product is noise in a screen
 * reader.
 */
export function ProductPanel() {
  return (
    <figure className="product-panel">
      {/* iOS Safari refuses to autoplay inline without playsInline: without it
          the element sits there with nothing painted into it, silently, no
          error anywhere - the empty box this fixes. */}
      <video className="product-panel-logo" src={logo} autoPlay muted loop playsInline />
    </figure>
  );
}
